import { lazy } from "react";

const ImportKTTList = lazy(() => import("./List"));
const ImportKTTCreate = lazy(() => import("./Create"));
const ImportKTTPrint = lazy(() => import("./Print"));
const ImportKTTUpdate = lazy(() => import("./Update"));
const UpdateKTTVat = lazy(() => import("./UpdateVat"));

export {
  ImportKTTCreate,
  ImportKTTList,
  ImportKTTPrint,
  ImportKTTUpdate,
  UpdateKTTVat,
};
